import React from 'react';
import './DashboardType12Chika.scss';
import CountReportCard from '../../../../Components/Chika/CountReportCard/CountReportCard';
import {
  InvoiceSVG,
  ProductLoadingSVG,
  IncomingEggSVG,
  ClockSVG
} from '../../../../Components/Chika/ChikaExportSvg/ChikaExportSvg';
import SimpleLineChart from '../../../../Components/Chika/SimpleLineChart/SimpleLineChart';
import DashboradProductTable from './DashboradProductTable/DashboradProductTable';
import CustomBarChart from '../../../../Components/Chika/CustomBarChart/CustomBarChart';
import BilanReportTable from './BilanReportTable/BilanReportTable';

const DashboardType12Chika = ({ dashboardComponentData }) => {
  const {
    anbar_kala,
    anbar_mahsol,
    bilans,
    orders,
    valuations,
    charts,
    average_order_time,
    waste_and_workbench
  } = dashboardComponentData;

  const orderTimeConfigs = [
    { key: "completed_to_delivered", label: "ثبت تا تحویل" },
    { key: "registered_to_ready", label: "ثبت تا تایید" },
    { key: "registered_to_completed", label: "تایید تا تکمیل" },
    { key: "completed_to_loading", label: "تایید تا بارگیری" },
    { key: "loading_to_delivered", label: "بارگیر تا تحویل" },
  ];

  const formatTime = (val) => {
    if (val === undefined || val === null || isNaN(val) || val < 0) return "0";
    return Number(val).toFixed(1);
  };

  const defaultMonthlyData = [
    { name: "فروردین", uv: 0 }, { name: "اردیبهشت", uv: 0 }, { name: "خرداد", uv: 0 },
    { name: "تیر", uv: 0 }, { name: "مرداد", uv: 0 }, { name: "شهریور", uv: 0 },
    { name: "مهر", uv: 0 }, { name: "آبان", uv: 0 }, { name: "آذر", uv: 0 },
    { name: "دی", uv: 0 }, { name: "بهمن", uv: 0 }, { name: "اسفند", uv: 0 }
  ];

  return (
    <section className="main-dashboard-12">
      <div className='stats-section'>
        <h2 className='stats-title'>انبار محصول</h2>
        <div className='product-warehouse-stats'>
          <CountReportCard
            egg={anbar_mahsol?.input?.egg}
            pack={anbar_mahsol?.input?.pack}
            title={"تعداد ورودی"}
            icon={<ProductLoadingSVG />}
            bgIcon={"#B7ECE4"}
          />
          <CountReportCard
            egg={anbar_mahsol?.output?.egg}
            pack={anbar_mahsol?.output?.pack}
            title={"تعداد خروجی"}
            icon={<ProductLoadingSVG />}
            bgIcon={"#B7ECE4"}
          />
          <CountReportCard
            egg={anbar_mahsol?.inventory?.egg}
            pack={anbar_mahsol?.inventory?.pack}
            title={"تعداد موجودی انبار"}
            icon={<ProductLoadingSVG />}
            bgIcon={"#B7ECE4"}
          />
        </div>
      </div>

      <div className='stats-section'>
        <h2 className='stats-title'>انبار کالا</h2>
        <div className='goods-warehouse-stats'>
          <CountReportCard
            egg={anbar_kala?.input?.egg}
            pack={anbar_kala?.input?.pack}
            title={"تعداد ورودی فله"}
            icon={<ProductLoadingSVG />}
            bgIcon={"#DADCFF"}
          />
          <CountReportCard
            egg={anbar_kala?.output?.egg}
            pack={anbar_kala?.output?.pack}
            title={"تعداد خروجی فله"}
            icon={<ProductLoadingSVG />}
            bgIcon={"#DADCFF"}
          />
          <CountReportCard
            egg={anbar_kala?.inventory?.egg}
            pack={anbar_kala?.inventory?.pack}
            title={"تعداد موجودی انبار"}
            icon={<ProductLoadingSVG />}
            bgIcon={"#DADCFF"}
          />
        </div>
      </div>

      <div className='stats-section'>
        <h2 className='stats-title'>تعداد سفارشات</h2>
        <div className='order-stats'>
          <CountReportCard
            egg={orders?.registered?.egg}
            title={"سفارش های ثبت شده"}
            icon={<InvoiceSVG />}
            bgIcon={"#DAF9C9"}
          />
          <CountReportCard
            egg={orders?.approved?.egg}
            title={"سفارش های تایید شده"}
            icon={<InvoiceSVG />}
            bgIcon={"#DAF9C9"}
          />
          <CountReportCard
            egg={orders?.completed?.egg}
            title={"سفارش های تکمیل شده"}
            icon={<InvoiceSVG />}
            bgIcon={"#DAF9C9"}
          />
          <CountReportCard
            egg={orders?.ready?.egg}
            title={"سفارش های آماده بارگیری"}
            icon={<InvoiceSVG />}
            bgIcon={"#DAF9C9"}
          />
          <CountReportCard
            egg={orders?.delivered?.egg}
            title={"سفارش های تحویل شده"}
            icon={<InvoiceSVG />}
            bgIcon={"#DAF9C9"}
          />
        </div>
      </div>

      <div className='stats-section'>
        <h2 className='stats-title'>ضایعات و میزکار</h2>
        <div className='product-line-stats'>
          <CountReportCard
            egg={waste_and_workbench?.kodi}
            title={"تعداد تخم مرغ کودی شکسته"}
            icon={<IncomingEggSVG />}
            bgIcon={"#F9D4C9"}
          />
          <CountReportCard
            egg={waste_and_workbench?.lombe}
            title={"تعداد تخم مرغ لمبه"}
            icon={<IncomingEggSVG />}
            bgIcon={"#F9D4C9"}
          />
          <CountReportCard
            egg={waste_and_workbench?.other}
            title={"تعداد تخم مرغ سایر"}
            icon={<IncomingEggSVG />}
            bgIcon={"#F9D4C9"}
          />
          <CountReportCard
            egg={waste_and_workbench?.workbench}
            title={"تعداد تخم مرغ میز کار"}
            icon={<IncomingEggSVG />}
            bgIcon={"#F9D4C9"}
          />
        </div>
      </div>

      <div className='stats-section'>
        <h2 className='stats-title'>میانگین زمانی سفارشات</h2>
        <div className='transfer-reports'>
          {orderTimeConfigs?.map((v, index) => (
            <div key={index} className="report-item">
              <div className="report-content">
                <h4 className="report-title">{v.label}</h4>
                <p className="report-value">
                  {formatTime(average_order_time?.[v.key])} ساعت
                </p>
              </div>
              <span className="report-icons">
                <ClockSVG />
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className='chart-section'>
        <SimpleLineChart
          title={"نمودار ماهانه تولید محصول"}
          data={charts?.monthly_product_production_chart?.length > 0 ? charts.monthly_product_production_chart : defaultMonthlyData}
          lineColor="#8D90CF"
          gradientStart={"#B7BBF9"}
          gradientEnd={"#FFF"}
          offsetStart={"0%"}
          offsetEnd={'100%'}
        />
        <CustomBarChart
          title={"نمودار نوع محصولات تولید شده روزانه"}
          data={charts?.daily_production_chart || []}
        />
      </div>

      <div className='chart-section'>
        <SimpleLineChart
          title={"نمودار ماهانه فروش محصول"}
          data={charts?.sales_monthly?.length > 0 ? charts.sales_monthly : defaultMonthlyData}
          lineColor="#8D90CF"
          gradientStart={"#B7BBF9"}
          gradientEnd={"#FFF"}
          offsetStart={"0%"}
          offsetEnd={'100%'}
        />
        <CustomBarChart
          title={"نمودار نوع محصولات فروش رفته روزانه"}
          data={charts?.daily_sales_product_chart || []}
        />
      </div>
      <div className='chart-section'>
        <CustomBarChart
          title={"نمودار سود ناخالص براساس ارزش"}
          data={charts?.gross_profit_chart || []}
        />
        <CustomBarChart
          title={"نمودار سود ناخالص براساس فی خرید"}
          data={charts?.gross_profit_fi_chart || []}
        />
      </div>

      <DashboradProductTable data={valuations} />
      <BilanReportTable data={bilans}/>

    </section>
  );
};

export default DashboardType12Chika;